import React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@material-ui/core';
import { useStylesMentorCard } from './styles';

import ChipList from '../../shared/chip-list';
import { MentorContentProps, MentorSectionProps } from './interface';

const MentorSection = ({
  list,
  title,
  children,
  info,
  type,
  className,
}: MentorSectionProps) => {
  const classes = useStylesMentorCard({});

  const hideSection = !list?.length && !children;

  if (hideSection) {
    return null;
  }

  return (
    <Box className={clsx(classes.section, className)}>
      <Typography className={classes.sectionTitle}>{title}</Typography>
      {Boolean(list?.length) && <ChipList list={list} />}
      {children}
      {info && <Typography className={classes.info}>{info}</Typography>}
    </Box>
  );
};

const MentorContent = ({
  name,
  education,
  description,
  className,
  sections = [],
}: MentorContentProps) => {
  const classes = useStylesMentorCard({});

  return (
    <Box className={className}>
      <Typography className={classes.name} variant="h3">
        {name}
      </Typography>
      <Typography className={classes.education}>{education}</Typography>
      <Typography className={classes.description}>{description}</Typography>

      {sections.map((section: any) => (
        <MentorSection {...section} />
      ))}
    </Box>
  );
};

export default MentorContent;
